/**
 * User: Rob Richard
 * Date: 6/9/14
 * Time: 2:54 PM
 */

'use strict';

module.exports = {
    getPeriodInDays: function (prop) {
        var period = this.get(prop);
        if (period) {
            return period.getInDays();
        }
        return 0;
    },
    getPeriodDisplayVal: function (prop) {
        var period = this.get(prop);
        if (period) {
            return period.getDisplayVal();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/periodMixin.js
// module id = 327
// module chunks = 62